import { apiClient } from "./apiClient";

const CODE_KEY = "beekeeper.signup_code";

/**
 * Stash a ?code= from the landing URL before sign-in redirects away.
 *
 * The code arrives on a marketing or referral link, and the B2C round trip
 * does not carry query parameters back -- so read once, at first load, or
 * it is gone by the time there is a form to put it in. sessionStorage, not
 * local: it belongs to this signup attempt and should not linger.
 */
/**
 * Remember an acquisition code from the URL a new user arrived on (#461).
 *
 * `ref` IS THE PARAMETER, NOT `code` (#475). OAuth's authorization-code
 * flow returns to the redirect URI carrying its OWN `code` parameter, so
 * reading `code` here meant a sign-in redirect could be captured as a
 * signup attribution -- truncated to 16 characters, which turns an auth
 * code into a plausible-looking string rather than an obviously wrong
 * one. That would quietly poison the one number a supplier asks for.
 *
 * `code` is still accepted, because a link may already exist with it,
 * but ONLY when `state` is absent. MSAL always sends `state` on an auth
 * redirect, so its presence is an exact tell that this is a sign-in
 * response and not somebody arriving from a card.
 *
 * Worth changing NOW rather than later: #423 is choosing distribution
 * vendors, and the moment a card is printed the parameter is fixed
 * forever.
 */
export function captureSignupCode(search = window.location.search) {
  try {
    const params = new URLSearchParams(search);
    const isAuthRedirect = params.has("state");
    const code = params.get("ref") || (isAuthRedirect ? null : params.get("code"));
    if (code) sessionStorage.setItem(CODE_KEY, code.trim().slice(0, 16));
  } catch {
    // A blocked or full sessionStorage must never stop the app loading.
    // Losing an attribution code is a cost; a blank page is not.
  }
}

export function rememberedSignupCode() {
  try {
    return sessionStorage.getItem(CODE_KEY) || "";
  } catch {
    return "";
  }
}

export function forgetSignupCode() {
  try {
    sessionStorage.removeItem(CODE_KEY);
  } catch {
    /* nothing to do, and nothing worth failing over */
  }
}

export const onboardingApi = {
  state: () => apiClient.get("/onboarding").then((r) => r.data),
  complete: (payload) => apiClient.post("/onboarding", payload).then((r) => r.data),
};
